<header class="header-container">
  <section class="header-navigation-info">
    <figure class="header-toggle-figure" (click)="toggleSideMenu()">
      <img
        class="header-toggle-image"
        src="svgs/icons/side-menu-toggle.svg"
        alt=""
      />
    </figure>
    <p class="route-title">{{ title.getTitle() | translate }}</p>
  </section>
  <section class="header-controls">
    <figure class="translation-figure" (click)="translate()">
      <img class="translation-image" [src]="langIcon" alt="" />
    </figure>
    <div class="divider"></div>
    <div class="user-info" #optionsContainer>
      <div class="controls">
        @if(loggedInUser()?.merchantProperties?.logo?.url){
        <figure class="merchant-figure">
          <img
            class="merchant-image"
            [src]="loggedInUser()?.merchantProperties?.logo?.url"
            [alt]="loggedInUser()?.merchantProperties?.logo?.name"
          />
        </figure>
        }@else {
        <div class="user-initials">
          <p class="name">
            {{
              extractInitials(
                loggedInUser()?.merchantProperties?.[
                  "common.dynamicName" | translate
                ]!
              )
            }}
          </p>
        </div>
        }
        <p class="username">
          {{
            loggedInUser()?.merchantProperties?.[
              "common.dynamicName" | translate
            ]! || "meanest alive"
          }}
        </p>
        <figure
          [ngClass]="{
            'arrow-up': isDropdownOpen(),
            'arrow-down': !isDropdownOpen()
          }"
        >
          <img src="svgs/icons/arrow-down.svg" alt="" />
        </figure>
      </div>

      @if(isDropdownOpen()){
      <div class="drop-down" id="drop-down">
        <div
          (mouseenter)="itemOnHover('settings')"
          (mouseleave)="itemOnHover(null)"
          class="drop-down-item"
          (click)="supports()"
        >
          <figure>
            <img [src]="settingsIcon()" alt="" />
          </figure>
          <p class="title">{{ "sideMenu.settings" | translate }}</p>
        </div>
        <div
          (mouseenter)="itemOnHover('logout')"
          (mouseleave)="itemOnHover(null)"
          class="drop-down-item"
          (click)="logout()"
        >
          <figure>
            <img [src]="logoutIcon()" alt="" />
          </figure>
          <p class="title">{{ "sideMenu.logout" | translate }}</p>
        </div>
      </div>
      }
    </div>
  </section>
</header>
